import { ElementRef, Injectable } from '@angular/core';
import { BehaviorSubject, interval, of, zip } from 'rxjs';
import { concatMap, delay } from 'rxjs/operators';

export interface FadeInOnIntersectingEvent {
    elementRef: ElementRef,
    direction: FadeInOnIntersectingDirection,
    delay?: number,
    duration?: number
}

export enum FadeInOnIntersectingDirection {
    UP = 'UP',
    DOWN = 'DOWN',
    LEFT = 'LEFT',
    RIGHT = 'RIGHT'
}


@Injectable({ providedIn: 'root' })
export class FadeInOnIntersectingService {

    private fadeInSubject: BehaviorSubject<FadeInOnIntersectingEvent> = null;

    constructor() {
        this.fadeInSubject = new BehaviorSubject(null);
        this.fadeInSubject.pipe(
            concatMap(v => of(v).pipe(delay(100))),
        ).subscribe(ev => {
            if(ev) this.performAnimation(ev);
        });
    }

    public animateEntry(ev: FadeInOnIntersectingEvent) {
        this.fadeInSubject.next(ev);
    }

    private performAnimation(ev: FadeInOnIntersectingEvent) {

        let translateStart: string = 'translate';
        if(ev.direction == FadeInOnIntersectingDirection.UP) translateStart += '(0px, 200px)';
        if(ev.direction == FadeInOnIntersectingDirection.DOWN) translateStart += '(0px, -200px)';
        if(ev.direction == FadeInOnIntersectingDirection.LEFT) translateStart += '(200px, 0px)';
        if(ev.direction == FadeInOnIntersectingDirection.RIGHT) translateStart += '(-200px, 0px)';

        if(!ev.elementRef.nativeElement) return console.log("No element found to animate");

        ev.elementRef.nativeElement.animate( // Animate the element in a cool way
            [
                { transform: translateStart, opacity: '0' },
                { transform: 'translate(0px, 0px)', opacity: '1' }
            ],
            {
                duration: ev.duration || 200,
                delay: ev.delay || 0,
                fill: "both",
                easing: 'ease-in-out'
            }
        );
    }


}
